import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { ExternalDataLoadingRequiredField } from './ExternalDataLoadingRequiredField';

export const ExternalDataLoadingRequiredFieldExtension =
  FormFieldBlueprint.make({
    name: 'external-data-loading-required-field',
    params: {
      field: async () =>
        createFormField({
          name: 'ExternalDataLoadingRequiredField',
          component: ExternalDataLoadingRequiredField,
        }),
    },
  });
